// src/components/chatbot/ChatbotButton.tsx
import React from 'react';
import { Bot } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

type ChatbotButtonProps = {
  onClick: () => void;
  unreadCount?: number;
};

const ChatbotButton: React.FC<ChatbotButtonProps> = ({ 
  onClick, 
  unreadCount = 0 
}) => {
  return (
    <Button
      onClick={onClick}
      className="fixed bottom-4 right-4 rounded-full h-14 w-14 shadow-lg z-50 p-0 flex items-center justify-center"
      aria-label="Open chat"
    >
      <Bot className="h-6 w-6" />
      {unreadCount > 0 && (
        <Badge 
          className="absolute -top-2 -right-2 bg-destructive text-destructive-foreground h-6 w-6 flex items-center justify-center p-0 rounded-full"
        >
          {unreadCount}
        </Badge>
      )}
    </Button>
  );
};

export default ChatbotButton;